import { render } from "./DocumentUploadModal.vue?vue&type=template&id=c856258c"
import script from "./DocumentUploadModal.vue?vue&type=script&lang=js"
export * from "./DocumentUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__